import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './RoleSelection.css';

function RoleSelection() {
  const navigate = useNavigate();

  return (
    <div className="role-selection">
      <div className="role-container">
        <img src="/pubsilo.png" alt="PubSilo" className="role-logo" />
        <h1>Join PubSilo</h1>
        <p>Choose your role to get started</p>
        
        <div className="role-cards">
          <div className="role-card">
            <div className="role-icon">📖</div>
            <h2>Reader</h2>
            <p>Discover and purchase premium content from expert authors</p>
            <Link to="/signup/reader" className="role-btn">Join as Reader</Link>
          </div>
          
          <div className="role-card">
            <div className="role-icon">🏢</div>
            <h2>Company</h2>
            <p>Publish premium content and monetize your audience through our platform</p>
            <Link to="/company-contact" className="role-btn">Join as Company</Link>
          </div>
        </div>
        
        <p className="login-link">
          Already have an account? <Link to="/login">Log in here</Link>
        </p>
      </div>
    </div>
  );
}

export default RoleSelection;
